module.exports = __webpack_public_path__ + "img/declined.45471e32.svg";